// F1 Races Component
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TableChart } from '../charts';

const RacesComponent = ({ data }) => {
  const [activeView, setActiveView] = useState('overview');
  const [selectedYear, setSelectedYear] = useState(null);
  // Transform race data to make names clickable
  const transformedRaces = data?.races?.map(race => ({
    ...race,
    year: (
      <Link 
        to={`/f1/seasons/${race.year}`}
        className="theme-primary hover:theme-accent hover:underline font-medium"
      >
        {race.year}
      </Link>
    ),
    name: (
      <Link 
        to={`/f1/races/${race.raceId}`}
        className="theme-primary hover:theme-accent hover:underline font-medium"
      >
        {race.name}
      </Link>
    ),
    circuit: (
      <Link 
        to={`/f1/circuits/${race.circuitId}`}
        className="theme-primary hover:theme-accent hover:underline font-medium"
      >
        {race.circuit}
      </Link>
    ),
    winner: race.winnerDriverId ? (
      <Link 
        to={`/f1/drivers/${race.winnerDriverId}`}
        className="theme-primary hover:theme-accent hover:underline font-medium"
      >
        {race.winner}
      </Link>
    ) : race.winner
  }));

  const renderRaces = () => (

    <TableChart data={transformedRaces || []}
    title="All Races"
    subtitle="Click on any race name to view detailed race information and results, click on circuit names to view track details, or click on winner names to view driver information."
      config={{
        columns: [
          { key: 'year', label: 'Year' },
          { key: 'round', label: 'Round' },
          { key: 'name', label: 'Race Name' },
          { key: 'circuit', label: 'Circuit' },
          { key: 'winner', label: 'Winner' },
          { key: 'date', label: 'Date' }
        ],
        sortable: true,
        searchable: true,
        sortBy: 'date',
        sortDirection: 'desc',
        pagination: true,
        pageSize: 10,
        showHeader: true,
        rowHeight: 40,
        headerHeight: 40,
        showFooter: true,
        footerHeight: 40
      }}
    />

  );

  return (
    <>
      <div className="mt-8">
        {renderRaces()}
      </div>
    </>
  );
};

export const racesConfig = {
  title: 'F1 Races',
  subtitle: 'Comprehensive race results, statistics, and historical data from Formula 1 events',
  summary: ['Race results', 'Track information', 'Season statistics'],
  stats: [
    { 
      value: (data) => data?.races?.length || 0, 
      label: 'Total Races',
    },
    { 
      value: new Date().getFullYear(), 
      label: 'Current Season',
    },
    { 
      value: (data) => data?.circuits?.length || 0, 
      label: 'Unique Circuits',
      color: 'theme-primary'
    }
  ],
  component: RacesComponent
};

export default RacesComponent;
